/* eslint-disable react/no-array-index-key */
import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

enum ProgressStepSection {
  FirstSection = 'first-section',
  SecondSection = 'second-section',
}

const OnboardingProgressFallback = ({
  profileProgressSection,
  isAgencyUser,
}) => {
  let totalSteps;
  if (profileProgressSection === ProgressStepSection.SecondSection) {
    totalSteps = 2;
  } else if (isAgencyUser) {
    totalSteps = 5;
  } else {
    totalSteps = 4;
  }

  return (
    <div className="onboarding-progress">
      <div className="d-flex justify-content-between align-items-center mb-2 skeleton-height-1">
        <SkeletonLoading width={270} height={20} />
        <SkeletonLoading width={110} height={20} />
      </div>

      {profileProgressSection === ProgressStepSection.FirstSection && (
        <div className="mb-3 d-flex align-items-center skeleton-height-1">
          <div className="d-flex align-items-center">
            <SkeletonLoading width={300} height={6} />
          </div>
          <span className="bs-ml-12">
            <SkeletonLoading width={130} height={18} />
          </span>
        </div>
      )}
      <div
        className={`d-flex onboarding-progress__items ${
          profileProgressSection === ProgressStepSection.SecondSection &&
          'onboarding-progress__items-secondary'
        } 
          `}
      >
        <div className="steps">
          <div className="steps__container">
            {Array.from({
              length: totalSteps,
            }).map((_, index) => (
              <div
                className="d-flex justify-content-between steps__item skeleton-height-1"
                key={index}
              >
                <div className="steps__item-label d-flex align-items-center skeleton-height-1">
                  <SkeletonLoading width={16} height={16} />
                  <SkeletonLoading width={100} height={20} className="ml-2" />
                </div>
                <SkeletonLoading width={80} height={16} />
              </div>
            ))}
          </div>
        </div>
        <div className="right-container right-container-skeleton d-flex justify-content-center align-items-center">
          <div className="d-flex justify-content-between align-items-center flex-1">
            <div className="left-section skeleton-height-1 w-100">
              <SkeletonLoading width="70%" height={20} />
              <SkeletonLoading width="80%" height={48} className="mt-3" />
            </div>
            <div className="right-section skeleton-height-1">
              <SkeletonLoading width={340} height={200} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingProgressFallback;
